import {defineMessages} from '@formatjs/intl';

export default defineMessages({
  'timeframe-today': {
    id: 'urgency.timeframe.today',
    defaultMessage: 'Today',
  },
  'timeframe-tomorrow': {
    id: 'urgency.timeframe.tomorrow',
    defaultMessage: 'Tomorrow',
  },
  'timeframe-thisWeek': {
    id: 'urgency.timeframe.thisWeek',
    defaultMessage: 'This week',
  },
  'timeframe-thisWeekend': {
    id: 'urgency.timeframe.thisWeekend',
    defaultMessage: 'This weekend',
  },
  'timeframe-nextWeek': {
    id: 'urgency.timeframe.nextWeek',
    defaultMessage: 'Next week',
  },
  'timeframe-inTwoWeeks': {
    id: 'urgency.timeframe.inTwoWeeks',
    defaultMessage: 'In two weeks',
  },
  'tickets-left': {
    id: 'urgency.ticketsLeft',
    defaultMessage: '{totalTickets, plural, =0 {No tickets left} one {One ticket left} other {# tickets left}}',
  },
  'tickets-left-many': {
    id: 'urgency.ticketsLeft.many',
    defaultMessage: '200+ tickets left',
  },
  'tickets-left-site': {
    id: 'urgency.ticketsLeft.site',
    defaultMessage:
      '{totalTickets, plural, =0 {No tickets left on our site} one {One ticket left on our site} other {# tickets left on our site}}',
  },
  'tickets-left-site-many': {
    id: 'urgency.ticketsLeft.site.many',
    defaultMessage: '200+ tickets left on our site',
  },
  'tickets-available': {
    id: 'urgency.ticketsAvailable',
    defaultMessage:
      '{totalTickets, plural, =0 {No tickets available} one {One ticket available} other {# tickets available}}',
  },
  'tickets-available-many': {
    id: 'urgency.ticketsAvailable.many',
    defaultMessage: '200+ tickets available',
  },
  'tickets-available-site': {
    id: 'urgency.ticketsAvailable.site',
    defaultMessage:
      '{totalTickets, plural, =0 {No tickets available on our site} one {One ticket available on our site} other {# tickets available on our site}}',
  },
  'tickets-available-site-many': {
    id: 'urgency.ticketsAvailable.site.many',
    defaultMessage: '200+ tickets available on our site',
  },
});
